import { InvoiceTypes } from "@/Constants";

export default class InvoiceInfo {
  dueDays: number = 30;
  type: string = InvoiceTypes.DEFAULT;

  public constructor(init?: Partial<InvoiceInfo>) {
    Object.assign(this, init);
  }
}
